export default "__VITE_ASSET__C5bFXS3V__"